import React, { useState } from "react";
import { TabPanelEmpty, TabPanelError, PageLoading } from "../../components";
import { StandardPageWrapper } from "../../components/layout/StandardPageWrapper";
import { PageHeader } from "../../components/layout/header/Header";
import { SettingsTabs } from "./SettingsTabs";
import { OrganizationUsersTable } from "../../components/users/OrganizationUsersTable";
import { useLocation } from "react-router-dom";
import { InviteUserDialog } from "../../components/dialog";
import { usePrimaryOrganizationId } from "../../hooks";
import { useSnackBar } from "@truevault/aquilo";
import { OrganizationUserDto } from "../../../common/service/server/dto/UserDto";
import { getUserFullName } from "../../util/user";

export const UserSettings = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const enqueueSnackbar = useSnackBar();

  const inviteHrUser = !!queryParams.get("invite_hr_user");

  const primaryOrgId = usePrimaryOrganizationId();

  const [showInviteHrUserDialog, setShowInviteHrUserDialog] = useState(inviteHrUser);

  return (
    <StandardPageWrapper>
      <div className="max-width-896">
        <PageHeader titleContent="Account Settings" marginBottomPx={0} />
        <SettingsTabs current="users" />
        <OrganizationUsersTable
          loadingElem={<PageLoading />}
          errorElemFn={(errorMessage: string) => <TabPanelError message={errorMessage} />}
          EmptyElem={<TabPanelEmpty message={"There are no users."} />}
        />
        {showInviteHrUserDialog && (
          <InviteUserDialog
            open={showInviteHrUserDialog}
            organizationId={primaryOrgId}
            onClose={() => setShowInviteHrUserDialog(false)}
            onDone={(invitedHrUser: OrganizationUserDto) => {
              setShowInviteHrUserDialog(false);

              enqueueSnackbar(
                `An invitation was sent to ${getUserFullName(
                  invitedHrUser,
                )} to join TrueVault as an HR user.`,
                { variant: "success" },
              );
            }}
            showDefaultSnackbarNotifications={false}
            onlyShowRole="HR"
            allowAddingHrUser={true}
          />
        )}
      </div>
    </StandardPageWrapper>
  );
};
